export default {
    route: {
        Permission: 'アクセス権限',
        RoleFrontPermission: 'フロントエンドアクセス権限',
        RoleBackPermission: 'バックエンドアクセス権限',
        Setting: 'システム設定',
        UserManager: 'ユーザー管理',
        UserList: 'ユーザーリスト',
        AddressManager: '住所管理',
        AddressList: '住所リスト',
        AddAddress: '住所の追加',
        MeterManager: 'メーター管理',
        Operate: '操作記録',
        MeterList: 'メーターリスト',
        MalfunctionList: '不良メーターリスト',
        LeakageList: '漏水メーターリスト',
        OrderList: '注文リスト',
        UserProfile: 'ユーザー情報',
        Account: 'アカウント',
        AccountInfo: 'アカウント情報',
        UpdatePassword: 'パスワードの変更',
        About: '…に関して',
        AccountList: 'アカウントリスト',
        Overview: '概要',
        AdminInfo: '管理者情報',
        UserBill: 'ユーザー請求書',
        CostsSet: '料金プラン',
        InstallerUser: '設置作業者',
        Message: 'メッセージ',
        Holiday: '祭日',
        SystemManagement: 'システム設定',
        AdminManagement: '管理者',
        CompanyList: '会社リスト',
        FirewareList: 'ファームウェアリスト',
        Network: 'ネットワーク',
        AddRsNetwork: "RS485ネットワーク追加",
        RsNetwork: "RS485ネットワーク",
        AddCompany: '会社の追加',
        AddAdmin: '管理者追加完了',
        AddCostSet: '支払い条件の追加',
        AddHoliday: '祭日の追加',
        AddUser: 'ユーザーの追加',
        AddInstallUser: '設置作業者の追加',
        AddFireware: 'ファームウェアの追加',
        MeterAnalyze: 'メーター分析',
        UserSetting: 'ユーザー設定',
        AddMeter: 'メーターの追加',
        MeterFirewareList: 'FW更新メーターリスト',
        Devices: 'デバイスの追加',
        DeviceControl: 'デバイス制御',
        DeviceSchedule: 'スケジュール',
    },
    navbar: {
        logOut: 'ログアウト',
        dashboard: 'ホームページ',
        github: '項目住所',
        theme: 'テーマ',
        size: 'テーマサイズ',
    },
    common: {
        warning: '警告',
        success: '成功',
        company: '公司',
        name: '名称',
        batchManager: '一括管理',
    },
    moneyUnit: {
        unit: '単価',
        JPY: '日本円',
        CNY: '人民元',
        USD: '米ドル',
    },
    language: {
        name: '言語',
        CN: '中文',
        JAP: '日本語',
        English: 'English',
    },
    login: {
        title: 'システム名',
        logIn: 'ログイン',
        rememberMe: '自動ログイン',
        username: 'ユーザー名',
        password: 'パスワード',
        comfirmPassword: 'パスワードの確認',
        any: '任意',
        thirdparty: '第三者ログイン',
        forgetPassword: 'パスワードを忘れましたか?',
        sendCode: '認証コードの発送',
        verificationCode: '認証コード',
    },
    documentation: {
        documentation: '書類',
        github: 'Github住所',
    },
    permission: {
        addRole: '権限の追加',
        editPermission: '権限の編集',
        roles: '権限',
        switchRoles: '権限の切り替え',
    },
    meterState: {
        s10: '電池電圧',
        s11: 'バルブ状態',
        s12: 'メーターカバー',
        s13: '時計同期',
        s14: '漏水',
        s15: '逆流',
        s16: '超過流量',
        s17: '通信イベント',
        s18: '水道メーターイベント',
        s21: '停電',
        s24: '電力状態',
        s25: 'タイムスイッチ設定',
        s26: '電圧',
        s28: '電力メーターイベント',
        s32: 'ガス停止',
        s35: 'ガス圧力',
        s36: '振動',
        s48: 'ヒートメーターイベント',
        s50: '電池電圧',
        s51: 'Wi-SUN通信',
        s54: '日照計異常',
        s58: '電力メーターイベント',
        fault: '異常',
        leakage: '漏水',
        noData: '過去4時間データ無し',
    },
    usage: {
        usage: '使用量',
        importEngery: '買電量',
        exportEnergy: '売電量',
        pVEnergy: '発電量',
        current: '電流',
        voltage: '電圧',
        frequency: '周波数',
        current1: "電流1",
        voltage1: "電圧1",
        frequency1: "周波数1",
        activePower1: '有効電力1',
        reactivePower1: '無効電力1',
        current2: "電流2",
        voltage2: "電圧2",
        frequency2: "周波数2",
        activePower: '有効電力',
        reactivePower: '無効電力',
        activePower2: '有効電力2',
        reactivePower2: '無効電力2',
        pyranometer: '日照計',
        pulseCountUsage: "パルス数",
        temperature: "温度",
        humidity: "湿度",
        routeBImportEnergy: "RouteB 買電量",
        routeBExportEnergy: "RouteB 売電量",
        pvExportEnergyUsage: "PV Export Energy",
    },
    table: {
        dynamicTips1: 'メーター順序の並び替え',
        dynamicTips2: 'クリック順で並び替え',
        dragTips1: '初期順序',
        dragTips2: 'ドラッグ後の順序',
        title: '表題',
        importance: '重要性',
        type: 'タイプ',
        remark: '備考',
        search: '検索',
        add: '追加',
        export: '抽出',
        reviewer: '審査人',
        id: 'メーター番号',
        date: '時刻',
        author: '作者',
        readings: '閲覧数',
        status: '状態',
        actions: '操作',
        edit: '編集',
        publish: '発行',
        draft: '原稿',
        delete: '削除',
        cancel: '取消',
        confirm: '確認',
        update: '更新',
        update1: 'アップデート',
        new: '追加',
        chart: 'チャート',
        map: '地図',
        reset: 'リセット',
        send: '発送',
        startTime: '開始時間',
        endTime: '終了時間',
        nextPage: '次ページ',
        prePage: '前ページ',
        createTime: '時刻の作成',
        preUpdate: '前回の更新',
        detail: '詳細',
        updateDate: '更新日',
        disable: '無効にする',
        enable: '有効にする',
        disableState: '無効状態',
        return: '戻る',
        clearForm: 'クリア',
        set: 'SET',
        get: 'GET',
        upload: "アップロード",
        browse:"参照",
        crc:"CRC",
        meter:"Meter"
    },
    element: {
        pleaseEnter: '入力してください',
        pleaseSelect: '選択してください',
        inputKeyWords: 'キーワードを入力してください',
        selectDate: '日付を選択してください',
        selectDateTime: '時刻を選択してください',
        selectMultiDate: '複数の日付を選択してください',
        selectAll: "全てを選択",
        check: "チェックを入れて選択",
    },
    excel: {
        export: '抽出',
        selectedExport: '選択項目の抽出',
        placeholder: 'ファイル名の入力',
        refresh: '刷新',
    },
    tagsView: {
        close: '閉じる',
        closeOthers: 'その他を閉じる',
        closeAll: '全てを閉じる',
    },
    company: {
        name: '会社名',
        logo: 'ロゴ',
        address: '住所',
        webURL: 'URL',
        email: 'E-Mail',
        phone: '電話',
        parentCompanyName: '契約会社',
        messageDate: '請求日',
        paymentDate: '支払日',
        zone: '时区',
        disableCompany: 'タイムゾーン',
        enableCompany: '有効な会社',
        leakageSetting: '漏水レート',
        waterLeakage: '水漏れ',
        powerLeakage: '漏電',
        gasLeakage: 'ガス漏れ',
        hotLeakage: '熱漏れ',
    },
    fireware: {
        name: 'ファームウェア名',
        url: 'ファームウェア場所',
        uploadFireware: 'ファームウェアの アップロード',
        upload: 'アップロード',
        version: 'バージョン',
        deleteFireware: 'ファームウェアの削除',
        pleaseSelectFireware: 'FWを選んでください',
        note: '備考',
        moduleModel: '通信モジュール型式',
        firmwareFileSize: 'ソフトファイルサイズ',
        selectFirmwae: 'ソフトを選択',
        selectedMeters: 'メーターを選択',
        uploadMeters: 'アップロード',
        uploadFile: 'ソフトファイルをアップロード'
    },
    meter: {
        meterID: 'メーターID',
        subPowerMeter: "收集電錶",
        meterType: 'メータータイプ',
        ownUser: 'ユーザー',
        setMeterParent: '親メーターの設定',
        changeMeterParent: '親メーターの変更',
        parentMeterID: '親メーターのID',
        unitPrice: '単価',
        addMeterCost: '料金システムの追加',
        updateMeterCost: '料金システムの変更',
        deleteMeterCost: '料金システムの削除',
        leakageQuantity: '漏水限度',
        reportTime: 'レポート時間',
        maintainReportTime: 'メンテナンス時間',
        faultType: '故障の種類',
        life: '寿命',
        maxReading: '最大読取数',
        bRouteMaxReading: 'Route B 最大読取数',
        cycle: 'メンテナンス周期',
        installDate: '設置日',
        state: 'メーター状況',
        address: '住所',
        parentMeter: '親メーター',
        usage: '消費',
        reads: '読取数',
        cost: 'コスト',
        expireDate: '締め日',
        selectTime: '時刻の選択',
        message: 'メッセージ',
        batchSetParent: '親メーターの設置',
        batchWrite: 'メーター設定',
        reading: '瞬間値読み取り',
        ota: 'OTA更新',
        broute: 'Bルート',
        brouteID: 'Bルート認証ID',
        brouteSecret: 'Bルート認証パスワード',
        GetInfo: "取得",
        openValve: 'バルブを開ける',
        closeValve: 'バルブを閉じる',
        clockSync: '時計の同期',
        electric: '電力',
        openLoad: '負荷を開路',
        closeLoad: '負荷を閉回路',
        loadControl: '負荷スイッチ制御',
        timeSwitchcontrol: 'タイムスイッチ制御',
        otherControl: 'その他の制御',
        alarm: '警報',
        alarmList: '警報リスト',
        installerUser: '設置者',
        bindUser: 'ユーザーのグループ化',
        analyze: '分析',
        deleteMeter: 'メーターを削除しますか？',
        disableMeter: 'メーターを無効にする',
        enableMeter: 'メーターを有効にする',
        meterReading: 'メーターを読み取り',
        eventLog: 'イベントログ',
        eventLogForRs485: 'イベントログ (for RS485 Slave)',
        clearKey: "キーのリセット",
        resetPointer: "データポインタをリセット",
        resetMeter: "メーターのリセット",
        resetCommModule: "通信モジュールのリセット",
        resetDailyMeter: "毎日メーターのリセット",
        selectLocation: "場所の選択",
        powerConditioner: "外部装置",
        Instant: '瞬間値読み取り',
        RangedEnergyReading: '時間範囲の読取数読み取り (for RS485 Slave)',
        RangedEventLog: '時間範囲のイベントログ',
        InstantPowerLineValue: '瞬間電力品質データ',
        ReadPowerLineValue: '電力線数値の読取り',
        GetVersionInfo: 'メーターIDとソフトバージョンの取得',
        Get30minRecordLogWithVoltage: "30分読取数と電圧の読み取り",
        Get30minRecordLog: "30分読取数の読み取り",
        GetDiagnosticInformation: "診断情報を取得",
        DiagnosticInformation: "診断情報 ",
        ConfirmClearKey: '警告：キーをリセットしてもよろしいですか？',
        versionCheck: 'ソフトバージョンの確認',
        upgrade: 'ソフトの更新',
        batchUpgrade: 'バッチの更新',
        subMeter: '子メーター',
        NetworkName: "ネットワーク名",
        NetworkBaudRate: "ネットワーク通信速度",
        Master: 'リーダーメーター',
        Slave: 'フォロワーメーター',
        NumberOfSlaveNumber: 'フォロワー数',
        ControlPanel: "コントロールパネル",
        Advance: 'アドバンス',
        SlaveMeterID: 'フォローワーメーターID',
        UnitNO: 'フォローワーメーター番号',
        ManualCommand: 'マニュアルコマンド',
        AdvanceCommands: 'アドバンスコマンド',
        Response: 'レスポンス',
        LastReportTime: '最終レポート時刻',
        Import: "順潮流",
        Export: "逆潮流",
        PulseInputCount: "入力パルス数",
        MeterStatu: "メーター状態",
        Current: "電流",
        Voltage: "電圧",
        Frequency: "周波数",
        Start: "開始",
        End: "終了",
        Command: 'コマンド',
        readingRecords: '記録の読取り',
        reCalculateUsage: "データのリセット",
        meterVersion: 'メーターのソフトバージョン',
        moduleId: '通信モジュールID',
        moduleVersion: '通信モジューのソフトバージョン',
        pulseFactor: "変換率",
        simCardInfo: "SIMカード設定",
        imsi: "IMSI",
        apn: "APN",
        user: "ユーザー名",
        password: "パスワード",
        authenication: "認証タイプ",
        authenicationTypes: ["なし", "PAP", "CHAP", "PAPまたはCHAP"],
        ipAddressAndPort: "IPアドレスとポート",
        ipAddress: "IPアドレス",
        port: "ポート番号 ",
        atuoRead: "定時読み取り",
        wifi: "Wi-Fi",
        wifiSSID: "Wi-Fi SSID",
        wifiPassword: "Wi-FI Password",
        sta: "STA",
        staSSID: "STA SSID",
        staPassword: "STA Password",
        mqttType: "Server Type",
        powerPlantId: '発電所ID',
        uploadSchedule: 'スゲジュール アップロード',
        cpc:'Program CPC',
        rs485SwitchControl:'RS485開關控制'
    },
    schedule: {
        stableSchedule:"固定スゲジュール",
        stableVersion:"バージョン",
        updateSchedule:"更新スゲジュール",
        updateVersion:"更新フラグ",
        updateInterval:"更新タイミング",
        count:"データ量",
        scheduleUpload:"スゲジュール アップロード"
    },
    device: {
        device: "デバイス",
        class: 'クラス',
        className: 'クラスネーム',
        deviceId: 'デバイスID',
        status: '状態',
        inUse: '使用中',
        getProperty: "プロパティ取得",
        oneProperty: "シングルプロパティ読み取り",
        mulitProperty: "マルチプロパティ読み取り",
        propertyName: "プロパティ",
        epc: "EPC",
        accessRule1: "accessRule1",
        accessRule2: "accessRule2",
        readingInputData: "データ",
        lastUpdateOn: "最後のレポート時間",
        remarks: "備考",
        sequenceOfData: "データの順序",
        downloadBuffer: "バッファをダウンロード ",
        reloadBuffer: "バッファを更新",
        scheduleJson: "定时JSON命令"
    },
    message: {
        maintenancePlan: 'メンテナンス計画',
        expireMessage: '費用通知',
        preNotifyDays: '{0}日前請求',
        NotifyDays: '毎月{0}日請求',
        defaultSevenDays: '初期設定7日前',
    },
    location: {
        location: '場所',
        latlng: '経度',
        longitude: ' 経度',
        latitude: '緯度',
        country: '国家',
        province: '県',
        city: '市',
        detail: '住所詳細',
        street: '町名',
        meterCount: 'メーター数量',
        userCount: 'ユーザー数量',
        totalUsage: '消費合計',
        totalCost: '料金合計',
    },
    diableState: {
        disabled: '無効',
        enabled: '有効',
    },
    meterTypes: {
        water: '水道メーター',
        power: '電力メーター',
        gas: 'ガスメーター',
        hot: 'ヒートメーター',
        pv: 'PVメーター',
    },
    meterTypeArray: ['水道メーター', '電力メーター', 'ガスメーター', 'ヒートメーター', 'PVメーター', 'ゲートウェイ', 'ゲートウェイーWi-Fi'],
    subMeterTypeArray: [
        ["Pluse Type", "Non-Pulse Type", "Remote unit"],
        ["Sub Meter", "Sub Meter with Pulse input", "Sub Meter RS485 - Master", "Sub Meter RS485-Slave"],
        ["Pluse Type", "Non-Pulse Type", "Remote unit"],
        [],
        ["Single Direction ", "Bi-Direction"],
        [],
    ],
    firmwareType: {
        water: '水道メーター',
        power: '電力メーター',
        gas: 'ガスメーター',
        hot: 'ヒートメーター',
        pv: 'PVメーター',
        gateway: 'ゲートウェイ',
        gateway_wifi: 'ゲートウェイーWi-Fi',
        cert:"Cert",
        ca_cert: 'CA cert',
        client_cert: 'Client cert',
        client_key: 'Client key',
        pcs_ca_ert:'PCS CA cert',
    },
    timeArray: {
        hours: '時間',
        days: '日',
        weeks: '週',
        months: '月',
        years: '年',
    },
    stateInfos: {
        totalCount: 'メーター総数',
        malfunctionCount: '故障総数',
    },
    date: {
        year: '年',
        month: '月',
        day: '日',
    },
    user: {
        email: 'E-Mail',
        userID: 'ユーザーID',
        userName: 'ユーザー名',
        portrait: 'ユーザーアイコン',
        address: '住所',
        editUser: 'ユーザー編集',
        phone: '電話',
        password: 'パスワード',
        oldPassword: '古いパスワード',
        newPassword: '新しいパスワード',
        confirmPassword: '新しいパスワードの確認',
        deleteUser: 'ユーザーの削除',
        frontRole: 'フロントエンドアクセス権限',
        backRole: 'バックエンドアクセス権限',
        role: '権限',
        position: '役職',
        disableAdmin: '管理者を無効にする',
        enableAdmin: '管理者を有効にする',
        disableUser: 'ユーザーを無効にする',
        enableUser: 'ユーザーを有効にする',
    },
    order: {
        payTime: '支払日',
        createTime: '日付の設定',
        money: '支付金额',
        payState: '支払状況',
        alredayPay: '支払済み',
        notPay: '未支払い',
        sendEmail: 'E-Mail送信',
    },
    costSet: {
        name: '料金プラン',
        normal: '支払い条件',
        addHolidayDate: '祭日の追加',
        saturday: '土曜日',
        sunday: '日曜日',
        holiday: '祭日',
        addRule: '支払い条件の追加',
        ruleType: '支払い条件のタイプ',
        timeRule: '時間制課金',
        usageRule: '従量制課金',
        startTime: '開始時間',
        endTime: '終了時間',
        startUsage: '開始時使用量',
        endUsage: '終了時使用量',
        please_input_usage: '使用量を入力してください',
        please_input_end_usage: '最大読取数を入れてください。初期値は99999999',
        nextCostSet: '前払いプラン',
        nextCostSetDate: '前払日付',
    },
    operate: {
        action: '行動',
        path: 'パス',
    },
    notification: {
        alreadyLastPage: '最終ページ',
        pleaseInputAllAddressInfo: '请填入完全的地址信息',
        pleaseInputName: '名前を入力してください',
        pleasePickOneDateAtLeast: '少なくとも一つの日を選択してください',
        saveSuccess: '保存完了',
        saveFail: '保存失敗',
        pleaseInputAll: '全ての項目を入力してください',
        inputIllegal: '不正な入力',
        addCompanySuccess: '会社追加完了!',
        addAdminSuccess: '管理者追加完了!',
        getEmailSuccess: 'E-Mail取得成功!',
        changePasswordSuccess: 'パスワード変更完了!',
        addHolidaySuccess: '祭日の追加完了!',
        getEmailError: '認証コード取得失敗!',
        emailCodeAlreadySend: '認証コード発送完了',
        dataPackageSendSuccess: 'デターパッケージ発送完了!!',
        addUserSuccess: 'ユーザー追加完了!',
        addInstallUserSuccess: '設置作業者追加完了!',
        updateUserInfoSuccess: 'ユーザー情報更新完了!',
        AddFirewareSuccess: 'ファームウェア追加完了!',
        AddMeterCostSuccess: '料金プラン追加完了',
        DeleteMeterCostSuccess: '料金プラン削除に成',
        BatchSetParentSuccess: '親メーターのグループ化完了!',
        BatchBindUserSuccess: 'ユーザーグループ化完了!',
        BatchBindMeterCostSuccess: '料金プラングループ化完了!',
        PleaseSelectMeterID: 'IDを選択してください',
        PleaseSelectUser: 'ユーザーを選択してください',
        PleaseSelectMeterCoust: '料金プランを選択してください',
        UpdateAdminSuccess: '管理者情報の更新完了!',
        DeleteAdminSuccess: '管理者の削除完了!',
        UpdatePasswordSuccess: 'パスワードの変更完了。改めてログインしてください!',
        MeterCostDateError: '不正な料金プラン変更!',
        UploadSuccess: 'アップロードに成功!',
        DisableCompanySuccess: '会社の無効化に成功!',
        EnableCompanySuccess: '会社の有効化に成功!',
        DisableAdminSuccess: '管理者の無効化に成功!',
        EnableAdminSuccess: '管理者の有効化に成功!',
        DisableMeterSuccess: 'メーターの無効化に成功!',
        EnableMeterSuccess: 'メーターの有効化に成功!',
        DateRangeHaveNoData: 'データの無い時間範囲!',
    },
    validate: {
        onlyNumberPermission: '数字のみ入力可',
        cannotGreaterThan30: '30以下の数量可',
        passwordMustGreaterThan8: 'パスワードは8文字以上',
        twoPasswordNotEqual: '二つのパスワードは合致していません!',
        email: '有効なE-有効なE-Mailを入力してください',
        valueNotNull: 'データの無い時間範囲',
    },
    param: {
        param1: 'パラメーター１',
        param2: 'パラメーター２',
        param3: 'パラメーター３',
        startTime: '開始時間',
        endTime: '終了時間',
    },
    routeDetail: {
        adminSignIN: '管理者登録',
        adminSignUP: '管理者ログイン',
        adminLogout: '管理者ログアウト',
        getAdminList: '管理者リストの取得',
        updateAdminPassword: '管理者パスワードの更新',
        updateAdmin: '管理者情報の更新',
        deleteAdmin: '管理者の削除',
        createInstallUser: '新しいユーザーの設置',
        forgetAdminPassword: 'パスワードを忘れましたか？',
        addPermissions: '管理者権限の追加',
        deletePermissions: '管理者権限の削除',
        bindRole: '管理者権限の追加',
        updateRole: '管理者権限の更新',
        deleteRole: '管理者権限の削除',
        users: 'ユーザーリストの取得',
        addMeter: 'メーターの追加',
        updateMeter: 'メーターの更新',
        meters: 'メーターリストの取得',
        setMeterParent: '親メーターの設定',
        changeMeterParent: '親メーターの変更',
        leakages: '漏水メーターリストの取得',
        orders: '請求書リスト',
        meterFaults: 'メーター故障メッセージ',
        addMeterCost: '料金プランの追加',
        deleteMeterCost: '料金プランの削除',
        updateMeterCost: '料金プランの更新',
        getMeterCosts: '料金プランリストの取得',
        addHolidaysDate: '祭日の追加',
        deleteHolidaysDate: '祭日の削除',
        updateHolidaysDate: '祭日の更新',
        getHolidaysDates: '祭日リストの取得',
        createCompany: '新しい会社の設置',
        deleteCompany: '会社の削除',
        updateCompany: '会社情報の更新',
        getCompanys: '会社リストの取得',
        createFireware: '新しいファームウェアの設置',
        deleteFireware: 'ファームウェアの削除',
        updateFireware: 'ファームウェアの更新',
        getFirewares: 'ファームウェアのリスト取得',
        exportMeterDatas: 'メーターデータの出力',
    },
    brandNames: ['OMRON', 'DeltaOHM', "Huawei", "Panasonic","IIL"],
    ModelNames: ['KP_M', 'KPK / KPV / KPW', 'HD9817TVS', 'SUN2000L-5ktl', 'VBPC244GM2S',"IIL2312"],
    Model2DataItems: ['直流入力電圧[1]', '直流入力電圧[2]', '直流入力電圧[3]', '直流入力電圧[4]', '直流入力電流[1]', '直流入力電流[2]', '直流入力電流[3]',
        '直流入力電流[4]', '直流入力電流（全入力合計）', '発電電力', '系統 W 相電圧', '系統 U 相電圧', '系統周波数', '総積算電力量', '動作ステータス', '表示エラーコード', '定格出力'],
    Model1DataItems: ['動作ステータス', '直流入力電圧', '直流入力電流', '系統 U 相電圧', '系統 W 相電圧', '発電電力', '日射強度', '気温', '総積算電力量', 'ユーザー積算電力量', '直流入力電圧[1]',
        '直流入力電流[1]', '直流入力電圧[2]', '直流入力電流[2]', '直流入力電圧[3]', '直流入力電流[3]', '直流入力電圧[4]', '直流入力電流[4]'],
    Model3DataItems: ["温度值", "温度值", "相対湿度", "露点", "露点", "湿球温度", "湿球温度", "状態レジスタ"],
    ModelHuaweiDataItems: ['Model', 'SN', 'PN', 'Model ID', 'Number of PV strings', 'Number of MPP trackers', 'Rated power (Pn)', 'Maximum active power (Pmax)', 'Maximum apparent power(Smax)', 'Maximum reactive power(Qmax fed to the power grid)',
        'Maximum reactive power(Qmax absorbed from the power grid)', 'State 1', 'State 2', 'State 3', 'Alarm 1', 'Alarm 2', 'Alarm 3', 'PV1 voltage', 'PV1 current', 'PV2 voltage',
        'PV2 current', 'PV3 voltage', 'PV3 current', 'PV4 voltage', 'PV4 current', 'Input power', 'Power grid voltage/Line voltage between phases A and B', 'Line voltage between phases B and C', 'Line voltage between phases C and A', 'Phase A voltage',
        'Phase B voltage', 'Phase C voltage', 'Power grid current/Phase A current', 'Phase B current', 'Phase C current', 'Peak active power of current day', 'Active power', 'Reactive power', 'Power factor', 'Grid frequency',
        'Efficiency', 'Internal temperature', 'Insulation resistance', 'Device status', 'Fault code', 'Startup time', 'Shutdown time', 'Accumulated energy yield', 'Daily energy yield', '[Energy storage] Rated capacity', '[Energy storage] Remaining capacity"',
        '[Energy storage] Running status', '[Energy storage] Main Line voltage', '[Energy storage] Main Line current', '[Energy storage] Charge and discharge power', '[Energy storage] Accumulated charge capacity', '[Energy storage] Accumulated discharge capacity',
        '[Energy storage] Current-day charge capacity', '[Energy storage] Current-day discharge capacity'],
    VBPC244GM2SDataItems:['Operation status', 'Abnormality contents', 'Grid linkage status', 'Linkage input/output instant power', 'Linkage output accumulated power',
        'Independent input/output instant power','Independent output accumulated power', 'Solar generation instant power', 'Solar generation accumulated power', 'Solar generation limit setting 2 (Power)', 
        'Selling power limit setting (Power)', 'Output control judgement', 'Panel capacity'],
        ModelIILDataItems:["Voltage (Factor 0.1, unit V)","Current (Factor 0.01, unit A)","Power (Factor 0.1, unit W (signed))","Total energy (Factor 0.01, unit kWh)","Measure voltage direction (0: Forward 1: Backward)","Total energy (Total energy )","Import energy (Factor 0.01, unit kWh)","Export energy (Factor 0.01, unit kWh)","Import energy (Factor 0.001, unit kWh)","Export energy (Factor 0.001, unit kWh)","Current (Factor 0.01, unit A (signed))","Import power (Factor 0.1, unit W (signed))","Export power (Factor 0.1, unit W (signed))","Voltage high-byte (Factor 0.01, unit V)","Current (Factor 0.001, unit A (signed))","Power (Factor 0.001, unit W (signed))"],
    powerConditioner: {
        content: '内容',
        data: '読出データ',
        brand: 'ブランド',
        mode: '型式',
        node: 'ノード',
        baudRate: 'ボーレート',
        command: 'アイテム',
        lastReportTime: '最後のレポート時間',
        responseCode: 'レスポンスコード',
        selectBrand: 'ブランドを選択してください',
        selectModel: '形式を選択してください',
        selectNode: 'ノードを選択してください',
        selectCommand: 'アイテムを選択してください',
        inputBaudRate: 'ボーレートを選択してください',
        allCommand: 'すべての命令',
        onlyOneMeterSupport: '1つメーターだけ選択してください',
        onlyPvMeterCanHandlePowerConditioner: 'PVメーターのみのパワーコンディショナー操作ができます',
    },
    ErrorMsg: {
        1008: '外部装置が応答するまでお待ちください',
    },
    RsNetworkInstantValueCommandNames: ['Meter ID(Low bytes)|0000|03', 'Meter Model(Low bytes)|0003|03', 'QR code string(Low bytes)|0006|08',
        '1st phase Voltage|000e|01', '1st phase Current|000f|01', '1st phase Frequency|0010|01', '1st phase Active Power|0011|01', '1st phase Reactive Power|0012|01',
        '2nd phase Voltage|0013|01', '2nd phase Current|0014|01', '2nd phase Frequency|0015|01', '2nd phase Active Power|0016|01', '2nd phase Reactive Power|0017|01',
        '3rd phase Voltage|0018|01', '3rd phase Current|0019|01', '3rd phase Frequency|001a|01', '3rd phase Active Power|001b|01', '3rd phase Reactive Power|001c|01',
        'Active Power|001d|01', 'Reactive Power|001f|01', 'Import Energy|0020|01', 'Export Energy|0021|01', 'Accumulate Pulse count|0022|01', 'Meter Status bit (0-9)|0023|01',
        'Route B Data Timetamp|0024|01', 'Route B Import Energy|0025|01', 'Route B Export Energy|0026|01', 'Route B 30m Data Timestamp|0027|01', 'Route B 30m Import Energy|0028|01', 'Route B 30m Export Energy|0029|01', 'Wi-SUN Status Timestamp|002a|01', 'Wi-Sun Status|002b|01',
        'Get all data|1111|44'],
    electricRecordDays: ["今日", "昨日", "2 Day before", "3 Day before", "4 Day before", "5 Day before", "6 Day before", "7 Day before", "8 Day before", "9 Day before",
        "10 Day before", "11 Day before", "12 Day before", "13 Day before", "14 Day before", "15 Day before", "16 Day before", "17 Day before", "18 Day before", "19 Day before",
        "20 Day before", "21 Day before", "22 Day before", "23 Day before", "24 Day before", "25 Day before", "26 Day before", "27 Day before", "28 Day before", "29 Day before",
        "30 Day before", "31 Day before", "32 Day before", "33 Day before", "34 Day before", "35 Day before", "36 Day before", "37 Day before", "38 Day before", "39 Day before",
        "40 Day before", "41 Day before", "42 Day before", "43 Day before", "44 Day before"],
    mqttType: {
        normal: "MQTT",
        tsl: "MQTT with TSL",
        aws: "AWS MQTT"
    }
};
